export default __webpack_public_path__ + "static/media/Reports.18945a0e.svg";